export const appFields = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            placeholder: 'Nice name for the app',
            required: true,
            label: 'App Name'
        }
    },
    {
        key: 'tenantId',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            label: 'Tenant',
            type: 'tenant',
            required: true,
            placeholder: 'Select'
        }
    },
    {
        key: 'apptypeId',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            type: 'apptype',
            label: 'App Type',
            required: true,
            placeholder: 'Select'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: 'Brief Description of the app',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'iconurl',
        type: 'input-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            placeholder: 'URL of the Icon for the app',
            required: false,
            label: 'Icon URL'
        }
    },
    // {
    //     key: 'realm',
    //     type: 'input-field',
    //     templateOptions: {
    //         type: 'text',
    //         description: 'Domain Name of the customer for partioning users, eg ampcome.com , google.com',
    //         required: true,
    //         label: 'Domain Name'
    //     }
    // },
    {
        key: 'url',
        type: 'input-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            description: 'OAuth 2.0 application URL.',
            required: false,
            label: 'OAuth 2.0 application URL'
        }
    },
    {
        key: 'callbackurls',
        type: 'input-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            description: 'callbackUrls The OAuth 2.0 code/token callback URL.',
            required: false,
            label: 'CallBack URLs'
        }
    },
    {
        key: 'owner',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.id',
        templateOptions: {
            type: 'text',
            placeholder: 'Id of the owner account',
            description: 'Owner ID of the application.',
            required: true,
            label: 'Owner Id'
        }
    },
    {
        key: 'navigation',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Vertical',
                value: 'vertical'
            }, {
                label: 'Horizontal',
                value: 'horizontal'
            }],
            label: 'Navigation Type',
            required: true,
            default: 'vertical',
            description: 'Menu Item Navigation Type'
        }
    },
    {
        key: 'status',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Disabled',
                value: 'disabled'
            }, {
                label: 'Production',
                value: 'production'
            }, {
                label: 'Sandbox',
                value: 'sandbox'
            }, {
                label: 'Trial',
                value: 'trial'
            }],
            label: 'Status',
            required: true,
            default: 'sandbox',
            description: 'Application Status'
        }
    },
    {
        key: 'defaulttimezone',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            type: 'timezone',
            options: [],
            label: 'Default Timezone',
            description: 'Default Timezone',
            required: true,
            placeholder: 'Select Default Timezone'
        }
    },
    {
        key: 'defaultcurrency',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            type: 'currency',
            options: [],
            label: 'Default Currency',
            description: 'Default Currency',
            required: true,
            placeholder: 'Select Default Currency'
        }
    },
    {
        key: 'mainpagelayout',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-4',
        templateOptions: {
            type: 'entitypagelayout',
            label: 'Tenant User Page Layout',
            description: "This is the layout for the home page for Tenant User",
            required: false
        }
    },
    {
        key: 'apppagelayout',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-4',
        templateOptions: {
            type: 'entitypagelayout',
            label: 'App User Page Layout',
            description: "This is the layout for the home page for App User",
            required: false
        }
    },
    {
        key: 'defaultdashboard',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-4',
        templateOptions: {
            type: 'dashboard',
            label: 'Default Dashboard Id',
            description: "Default Dashboard for the Tenant User",
            required: false
        }
    },
    {
        key: 'defaultappdashboard',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-4',
        templateOptions: {
            type: 'dashboard',
            label: 'Default Dashboard Id',
            description: "Default Dashboard for the App User",
            required: false
        }
    },
    {
        key: 'countries',
        type: 'select-component',
        className: 'col-md-12',
        templateOptions: {
            type: 'country',
            label: 'Countries',
            multiple: true,
            description: "Choose Countries",
            required: true
        }
    },
    {
        key: 'currencies',
        type: 'select-component',
        className: 'col-md-12',
        templateOptions: {
            type: 'currency',
            label: 'Currencies',
            multiple: true,
            description: "Choose Currencies",
            required: true
        }
    },
    {
        key: 'timezones',
        type: 'select-component',
        className: 'col-md-12',
        templateOptions: {
            type: 'timezone',
            label: 'Time Zones',
            multiple: true,
            description: "Choose Time Zones",
            required: true
        }
    },
    {
        key: 'reportfootertext',
        type: 'input-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            label: 'Footer Text to be shown on reports',
            required: false,
            placeholder: ''
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/app.ts